import angular from 'angular'
import template from './template.html'

angular.module('nominas.nomina')
  .component('nominasNominaColaboradoresAgregarIndividualColaborador', {
    template: template,
    controller: NominasNominaColaboradoresAgregarIndividualColaboradorComponent,
    bindings: {
      data: '<',
      onChange: '&',
      onClose: '&',
    },
    require: {
      nomina: '^nomina',
    },
  })

function NominasNominaColaboradoresAgregarIndividualColaboradorComponent($catalogos, NominasNominaInformacionTipocambio) {
  let $ctrl = this

  $ctrl.$onInit = $onInit
  $ctrl.aceptar = aceptar
  $ctrl.cerrar = cerrar

  function $onInit() {
    $ctrl.data = angular.extend({
      id_moneda: $ctrl.nomina.data.id_moneda,
      tipo_cambio: undefined,
      comision_porcentaje: 0,
      comision_importe: 0,
      importe: null,
      importe_divisa: null,
      neto: 0,
      total_percepciones: 0,
      total_deducciones: 0,
      neto_a_pagar: null,
      status_calculado: 0,
      percepciones: {},
      deducciones: {},
    }, $ctrl.data)

    $ctrl.$promise = NominasNominaInformacionTipocambio.get($ctrl.data.id_empresa, $ctrl.data.id_nomina)
      .then(function (response) {
        $ctrl.data.tipo_cambio = response.data.tipo_cambio

        return conceptos($ctrl.data.config.id_regimen_fiscal)
      })
  }

  function aceptar(valid) {
    if (!valid)
      return

    $ctrl.onChange({$event: {data: $ctrl.data}})
  }

  function cerrar() {
    $ctrl.onClose({$event: {}})
  }

  function conceptos(id_regimen_fiscal) {
    if (id_regimen_fiscal === 2) {
      return $catalogos.get('movimientos')
        .then(function (data) {
          $ctrl.conceptos = data
        })
    } else {
      return $ctrl.conceptos = []
    }
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/colaboradores/agregar/individual/colaborador/component.js